import { UiContactFormModel } from "../../models";

export function mockUiContactFormModel({
    id = "contact-form-1234",
    type = "uiContactForm",
    locale = "en",
    content = mockUiContactFormModelContent()
}: Partial<UiContactFormModel> = {}): UiContactFormModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiContactFormModelContent = UiContactFormModel["content"];

export function mockUiContactFormModelContent({
    title = "Example contact form",
    ...optionals
}: Partial<UiContactFormModelContent> = {}): UiContactFormModelContent {
    return {
        title,
        ...optionals
    };
}
